<xi-generic-modal
  [customPadding]="{ top: '0', right: '0', bottom: '0', left: '0' }"
  [isVisible]="true"
  maxWidth="660px"
  (onClose)="cancel()"
>
  <div slot="children">
    <xi-basic-tile [hasTopBar]="false" [stretch]="true" [isInteractive]="false">
      <div slot="children">
        <div
          *transloco="let t; read: 'project-create'"
          class="xi-modal__container project-create__container"
        >
          <h2 class="xi-modal__title">{{ t('title') }}</h2>

          <div class="xi-modal__content">
            <form autocomplete="off">
              <div class="xi-input-field-wrapper">
                <xi-input-field
                  [placeholder]="t('name-project')"
                  [label]="t('name')"
                  [(ngModel)]="name"
                  name="name"
                  required
                  [status]="projectNameStatus"
                  [prePopulateStatus]="true"
                  (onChange)="onValidateProjectName()"
                  appAutoFocus="xiInput"
                ></xi-input-field>
              </div>

              <div class="xi-input-field-wrapper">
                <xi-input-field
                  [placeholder]="t('description-project')"
                  [label]="t('description')"
                  [(ngModel)]="description"
                  name="description"
                  #descriptionInput="ngModel"
                  [status]="
                    descriptionInput.value?.length > 256
                      ? {
                          state: 'error',
                          text: t('error-description'),
                        }
                      : { state: 'success' }
                  "
                  [prePopulateStatus]="true"
                ></xi-input-field>
              </div>
            </form>
          </div>

          <div class="project-create__action xi-modal__actions">
            <div class="xi-loader-button-container">
              <xi-default-button
                [text]="t('confirm')"
                buttonSize="large"
                [disabled]="!canConfirm()"
                (onClick)="confirm()"
              ></xi-default-button>

              @if (isLoading.confirm) {
                <div class="xi-loader-container__inline-overlay">
                  <xi-animation
                    [height]="100"
                    [width]="100"
                    [loop]="true"
                    animation="cx_loader"
                  ></xi-animation>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </xi-basic-tile>
  </div>
</xi-generic-modal>
